module.exports = __webpack_public_path__ + "static/media/nocode.a8b35bfc.mp4";